"use strict"

jQuery( document ).ready( function ( $ ) {

	// Add a required attribute to search input field to prevent
	// sending the empty search form on the front-end.
	var searchInputField = $( '#s' );
	searchInputField.attr( "required", "required" );

	// This is to move the search form dynamically in the DOM.
	var searchContainer;
	var searchForm;
	var docWidth;
	var navMenu;

	function defineAndRefreshHooks() {
		searchContainer = document.getElementById( "jsSearchContainer" );
		searchForm = document.getElementById( "jsSearchForm" );
		navMenu = document.getElementById( "navList" );
		docWidth = document.documentElement.clientWidth
	}

	function moveSearchSection( width ) {
		if ( $( searchInputField ).is( ":focus" ) ) {
			// Input is in focus, don't do anything or it loses focus
			// and keyboard dissapears (on mobile).
			// This is because when the keyboard gets opened,
			// Android will trigger a resize event on the window,
			// which therefore causes a continuous resize loop to
			// happen - and that essentially hides the keyboard.
		} else {
			if ( width < 975 ) { // 975 = 992 - UI elements
				searchForm.classList.add( "navigation__search--mobile-view" );
				navMenu.parentElement.appendChild( searchForm )
			} else {
				searchForm.classList.remove( "navigation__search--mobile-view" );
				searchContainer.appendChild( searchForm )
			}
		}
	}

	if ( $( '#jsSearchForm' ).length > 0 ) {

		defineAndRefreshHooks();

		searchForm.style.visibility = "visible";

		moveSearchSection( docWidth );

		window.addEventListener( "resize", function () {
			defineAndRefreshHooks();
			moveSearchSection( docWidth );
		} );
	}
} );
